export class SKU {
    constructor(
        public id: string,
        public price: number | null,
        public onSale: boolean,
        public dateCreated: Date,
        public dateUpdated: Date
    ) { }
}
